<p-dialog
  [(visible)]="showLogPopup"
  [modal]="true"
  [style]="{ width: '60%' }"
  [header]="'case.labmed.popup-header' | translate"
  (onHide)="onHide()"
>
  <div class="log-popup" *ngIf="showLogPopup">
    <div class="log-filters">
      <button
        class="filter-btn"
        [class.active]="activeFilter === 'all'"
        (click)="setFilter('all')"
      >
        {{ "case.labmed.all" | translate }} ({{ logs?.length }})
      </button>
      <button
        class="filter-btn success"
        [class.active]="activeFilter === 'success'"
        (click)="setFilter('success')"
      >
        {{ "case.labmed.success" | translate }} ({{ numberOfSuccess }})
      </button>
      <button
        class="filter-btn error"
        [class.active]="activeFilter === 'error'"
        (click)="setFilter('error')"
      >
        {{ "case.labmed.fail" | translate }} ({{ numberOfFail }})
      </button>
    </div>

    <div class="log-content">
      <div class="log-list" *ngIf="filteredLogs.length > 0; else noLogs">
        <div
          class="log-entry"
          [class.success]="log?.isSuccess"
          [class.error]="!log?.isSuccess"
          *ngFor="let log of filteredLogs; trackBy: trackByIndex"
        >
          <div class="log-entry-header">
            <div class="status-indicator">
              <div
                class="status-icon"
                [class.success]="log?.isSuccess"
                [class.error]="!log?.isSuccess"
              >
                <svg
                  *ngIf="log.isSuccess"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20,6 9,17 4,12"></polyline>
                </svg>
                <svg
                  *ngIf="!log.isSuccess"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              <span class="status-text">
                {{
                  log?.isSuccess
                    ? ("common.success" | translate)
                    : ("common.error" | translate)
                }}
              </span>
            </div>

            <div class="log-meta">
              <span class="timestamp">{{
                log.createdAt | dateFormat : true
              }}</span>
            </div>
          </div>

          <div class="log-details">
            <div class="detail-section">
              <span class="font-weight-bold"
                >{{ "case.labmed.method" | translate }}:</span
              >
              <span class="method"> {{ log.type }}</span>
            </div>

            <div class="detail-section" *ngIf="log.createdBy">
              <span class="font-weight-bold"
                >{{ "case.labmed.createdBy" | translate }}:</span
              >
              <span class="created-by">
                {{ log?.createdBy?.firstName }}
                {{ log?.createdBy?.lastName }}</span
              >
            </div>

            <div class="detail-section">
              <span class="font-weight-bold"
                >{{ "case.labmed.description" | translate }}:</span
              >
              <span class="created-by">
                {{ log?.description }}
              </span>
            </div>

            <div
              class="detail-section collapsible"
              *ngIf="log.type !== 'LabmedTamamla' &&  log.type !== 'RaporGonder'"
            >
              <button class="collapse-btn" (click)="toggleDetails(log)">
                <span class="font-weight-bold">{{
                  "case.labmed.details" | translate
                }}</span>
                <svg
                  class="chevron"
                  [class.rotated]="log.showDetails"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
              </button>

              <div
                class="collapsible-content"
                [class.expanded]="log.showDetails"
              >
                <div class="json-container">
                  <h4>
                    {{ "case.labmed.request" | translate }}:
                    <i
                      class="pi pi-copy pointer"
                      role="button"  tabindex="-1" (click)="copySText(log, 'request')"
                    ></i>
                  </h4>
                  <pre class="json-content">{{ log.request }}</pre>

                  <h4>
                    {{ "case.labmed.response" | translate }}:
                    <i
                      class="pi pi-copy pointer"
                      role="button"  tabindex="-1" (click)="copySText(log, 'response')"
                    ></i>
                  </h4>
                  <pre class="json-content">{{ log.response }}</pre>
                  <div
                    class="copy-notification"
                    [class.show]="showNotification"
                  >
                    {{ "case.copy" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noLogs>
        <div class="no-logs">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <path
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          <p>{{ "case.labmed.no-logs" | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</p-dialog>

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
